import React from "react";
import { mapSign } from "@/helpers/getCompatibilityBetweenSigns";
import CompatibilityLinkList from "../CompatibilityLinkList";

const SignsCharacteristics = (props) => {

  const listSigns = Object.entries(mapSign).map(([key, sign]) => ({
    img: `/img/westernastrology/${key}.svg`,
    textLink: `Cómo son los ${sign}`,
    url: `/horoscopo/signos-zodiaco-${key}`,
    label: `Características de ${sign}`,
    alt: `Signo de ${sign}`,
  }));

  return (
    <CompatibilityLinkList items={listSigns} title={`Características de los signos del zodiaco`}/>
  );
};

export default SignsCharacteristics;
